module.exports = __webpack_public_path__ + "img/audio.5b29458d.svg";